import axios from 'axios';
import { client } from '@/services/api/axios.ts';
import { useMutation } from '@tanstack/react-query';

type TPostRegister = {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
};

async function register({
  firstName,
  lastName,
  email,
  password,
}: TPostRegister): Promise<{ body: { email: string; code: string } } | undefined | void> {
  // const promise = new Promise((res) => {
  //   setTimeout(() => {
  //     res({ firstName, lastName, email, password });
  //   }, 3000);
  // });

  // await promise;
  try {
    const { data } = await client.post('/auth/register', {
      firstName,
      lastName,
      email,
      password,
    });

    return data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(`${error?.response?.data?.message}`);
    }

    if (error instanceof Error) {
      throw new Error(`${error.message}}`);
    }
  }
}

export const useRegisterUserQuery = ({
  onSuccess,
}: {
  onSuccess: (data: { body: { email: string; code: string } } | undefined) => void;
}) => {
  return useMutation({
    mutationFn: register,
    onSuccess: (data = { body: { email: '', code: '' } }) => {
      if (onSuccess) onSuccess(data);
    },
  });
};
